import React, { useState } from "react";

interface CardTemplateProps {
    title?: string | React.ReactNode;
    children: React.ReactNode;
    className?: string;
    px?: string;
}

const CardTemplate = ({ title, children, className = "", px = "px-4 tablet:px-12" }: CardTemplateProps) => {
    const [isActive, setIsActive] = useState(false);

    return (
        <div
            onFocus={() => setIsActive(true)}
            onBlur={(e) => {
                if (!e.currentTarget.contains(e.relatedTarget as Node)) {
                    setIsActive(false);
                }
            }}
            onMouseEnter={() => setIsActive(true)}
            onMouseLeave={() => setIsActive(false)}
            className={`bg-base-100 rounded-2xl w-[370px] tablet:w-[448px] min-h-[236] tablet:min-h-[280px] flex flex-col gap-5 overflow-hidden ${className}`}
        >
            {title && (
                <div
                    className={`w-full min-h-[52px] tablet:h-[76px] flex items-center justify-center transition-colors duration-200 ${
                        isActive ? "bg-info" : "bg-base-300"
                    }`}
                >
                    {typeof title === "string" ? (
                        <h2 className="text-xl font-semibold text-base-content text-center p-2">{title}</h2>
                    ) : (
                        title
                    )}
                </div>
            )}
            <div className={`${px} pb-6 tablet:pb-12 font-sans font-semibold text-sm leading-5`}>{children}</div>
        </div>
    );
};

export default CardTemplate;
